import React from 'react';
import cx from 'classnames';
import Icon from '../Icon/index.js';
import unitType, { defaultUnitType } from './types/unit.js';
import highlight from './highlight.js';

const renderUnitIcon = (complete, labels) => /*#__PURE__*/React.createElement(Icon, {
  assistiveText: {
    label: complete ? labels.completed : labels.incomplete
  },
  category: "action",
  name: complete ? "approval" : "back",
  size: "x-small",
  containerClassName: complete ? "tds-bg_success" : "tds-content-brick__unit-icon",
  className: cx({
    "tds-content-brick__unit-icon_forward": !complete
  })
});
renderUnitIcon.displayName = "renderUnitIcon";
const Unit = ({
  title,
  titleHighlights,
  completionTime,
  complete,
  description,
  descriptionHighlights,
  labels,
  path,
  a11yHidden,
  onClick
}) => {
  const renderTitle = () => {
    if (titleHighlights) {
      return /*#__PURE__*/React.createElement("a", {
        tabIndex: a11yHidden ? "-1" : "0",
        href: path,
        className: "tds-content-panel__unit-link tds-color_brand tds-text_bold",
        onClick: onClick,
        dangerouslySetInnerHTML: {
          __html: highlight(title, titleHighlights)
        }
      });
    }
    return /*#__PURE__*/React.createElement("a", {
      tabIndex: a11yHidden ? "-1" : "0",
      href: path,
      className: "tds-content-panel__unit-link tds-color_brand tds-text_bold",
      onClick: onClick
    }, title);
  };
  const renderDescription = () => {
    if (descriptionHighlights) {
      return /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: highlight(description, descriptionHighlights)
        }
      });
    }
    if (description) {
      return /*#__PURE__*/React.createElement("div", null, description);
    }
    return null;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cx(complete ? null : "tds-content-panel__unit-incomplete", "tds-content-panel__unit slds-grid slds-border_bottom"),
    "data-test": "unit-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "slds-grow slds-m-vertical_small slds-m-right_large"
  }, renderTitle(), renderDescription(), /*#__PURE__*/React.createElement("div", {
    className: "tds-color_meteorite"
  }, completionTime)), /*#__PURE__*/React.createElement("div", {
    className: "slds-p-left_medium slds-shrink-none slds-m-vertical_small slds-align-content-center slds-text-align_right"
  }, !complete && /*#__PURE__*/React.createElement("a", {
    tabIndex: "-1",
    href: path,
    onClick: onClick
  }, renderUnitIcon(complete, labels)), complete && renderUnitIcon(complete, labels)));
};
Unit.displayName = "Unit";
Unit.propTypes = unitType;
Unit.defaultProps = defaultUnitType;
var Unit$1 = Unit;

export { Unit$1 as default };
